import { format } from 'date-fns';
import { useRouter } from 'next/router';
import React from 'react';

import {
  useGetSupplier,
  useGetSupplierExperience,
  useGetSupplierNationalIDImages,
} from '@/modules/workforce/Crew/apiHooks';
import IdCard from '@/modules/workforce/Crew/components/Crews/CrewDetails/Experience/SupplierIdCard';
import InfoCard from '@/modules/workforce/Crew/components/Crews/CrewDetails/InfoCard';
import { Loading } from '@/shared/components/atoms';

const Experience = () => {
  const { query } = useRouter();

  const { data: exp } = useGetSupplierExperience({
    supplierId: Number(query?.id),
    todayDate: format(new Date(), 'yyyy-MM-dd'),
  });
  const { data: supplier, isLoading } = useGetSupplier({
    supplierId: Number(query?.id),
    todayDate: format(new Date(), 'yyyy-MM-dd'),
  });

  const { data: supplierId } = useGetSupplierNationalIDImages({
    supplierId: Number(query?.id),
  });

  if (isLoading) {
    return (
      <div className='mt-100'>
        <Loading />
      </div>
    );
  }

  return (
    <div className='flex flex-col gap-24'>
      {!!supplier && <InfoCard experience={exp} {...supplier} />}
      <IdCard {...supplierId} />
    </div>
  );
};

export default Experience;
